__turbopack_context__.v({
  "container": "JNUeWW_container",
  "isSelected": "JNUeWW_isSelected",
});
